export default __webpack_public_path__ + "static/media/sign-up.29a1d597.png";